import axios from "axios";
import { PaginationParams } from "./hooks/account";
import {
  generateAndEncryptData,
  verifyEncryptionSetup,
} from "../utils/encryption";

export const BASEURL = process.env.REACT_APP_BASE_URL;

export const api = {
  users: {
        refreshUserToken: "/users/refresh-token",
    getUser: (userId: string) => `/users/${userId}`,
    verify: "/users/login/verify",
    requestAccess: "/users/request-access",
    invitationVerify: "/users/invitations/verify",
    individualKyc: "/users/individual/kyc",
    users: "/users",
    businessKyc: "/users/business/kyc",
    userLogin: "/users/login",
    recoverPassword: "/users/recover-password",
    resetPassword: "/users/reset-password",
    usersInvitations: "/users/invitations",
    generateBeneficiaryForm: "/users/forms/beneficiary/generate",
    invitees: (userId: string) => `/users/${userId}/invitees`,
    otpRequest: (userId: string) => `/users/${userId}/request-otp`,
    signUpVerify: "/users/signup/verify",
    updateBank: "/users/update-bank",
    checkEmail: "/users/check-email",
    usersBusinessDetails: (businessId?: string) =>
      `/backoffice/business/${businessId}`,
    rejection: "/users/business/rejection",
    rejectionReasons: "/users/rejection/reasons",
    businessDocumentDecision: "/backoffice/business-document-decision",
    businessKYCDecision: "/backoffice/business-kyc-decision",
    businessContactDecision: "/backoffice/business-contact-decision"
  },
  metadata: {
    banks: "/metadata/banks",
    resolveBankName: "/metadata/account/resolve-name",
    rates: "/metadata/rates",
  },
  wallet: {
    AccountNgn: "/wallet/accounts/ngn",
    walletAccount: (currency: string) => `/wallet/accounts/${currency}`,
    AccountUsd: "/wallet/accounts/usd",
    AccActivity: "/wallet/accounts/activity",
    BuyUsd: "/wallet/buy/usd",
    Beneficiaries: "/wallet/beneficiaries",
    buyCurrency: (currencyCode: string) => `/wallet/buy/${currencyCode}`,
    beneficiaryIdentity: (beneficiaryId: string) =>
      `/wallet/beneficiaries/${beneficiaryId}`,
    transfersUsd: "/wallet/transfer/usd",
    accountWithdrawal: "/wallet/accounts/withdrawal",
    transactionReference: (reference: string) =>
      `/wallet/transactions/${reference}`,
    createNgnBeneficiary: "/wallet/ngn/beneficiaries",
    ngnBeneficiaryIdentity: (beneficiaryId: string) =>
      `/wallet/ngn/beneficiaries/${beneficiaryId}`,
  },
  flag: {},
  tags: {
    rates: "/metadata/rates",
    ratesEur: "/metadata/rates/eur",
    gbpRates: "/metadata/rates/gbp",
    swiftCountries: "/metadata/countries/swift",
    ibanCountries: "/metadata/countries/iban",
    abaCountries: "/metadata/countries/aba",
    states: "/metadata/states",
    abaDistricts: "/metadata/districts/aba",
  },
  externals: {
    externalBeneficiary: "/external/beneficiaries",
  },
  invitations: {
    invitation: "/backoffice/invitations/all",
  },
  admin: {
    adminUsers: "/admin/users",
    adminUsersNew: "/backoffice/users/individuals",
    adminBusinessUserNew: "/backoffice/users/business",
    invitation: (email: string) => `/backoffice/invitations/${email}/resend `,
    getUserByRef: (ref: string) => `/users/invitation/${ref}`,
    getUserPrev: (id: string | null) => `/role/pages-by-userid/${id}`,
    adminUser: (id?: string) => `/admin/users/${id}`,
    adminFees: "/backoffice/fees",
    functionality: "/functionalityManagement",
    allFunctionality: "/functionalityManagement/general",
    BankList: "/users/lbp/local/banks",
    resolveBankName: "/users/lbp/verifyAccountNumber",
    modifyFunctionality: (id: string) => `/functionalityManagement/${id}`,
    adminRates: (currency: string) => `/admin/rates/${currency}`,
    adminTx: (userId: string) => `/admin/${userId}/transactions`,
    adminNgn: (userId: string) => `/admin/${userId}/wallet/ngn`,
    adminUsd: (userId: string) => `/admin/${userId}/wallet/usd`,
    adminGbp: (userId: string) => `/admin/${userId}/wallet/gbp`,
    adminEur: (userId: string) => `/admin/${userId}/wallet/eur`,
    adminUsdt: (userId: string) => `/admin/${userId}/wallet/usdt`,
    adminUsdc: (userId: string) => `/admin/${userId}/wallet/usdc`,
    getUser: (userId: string) => `/admin/users/${userId}`,
    patchFees: (Id: string) => `/admin/fees/${Id}`,
    deleteFees: (Id: string) => `/admin/fees/${Id}`,
    feeById: (Id: string) => `/admin/fees/${Id}`,
    userStatus: `/admin/profile/status`,
    businessKycStatus:
      `/backoffice/business-kyc-decision`,
    businessContactKycStatus:
      `/backoffice/business-contact-decision`,
    businessCorporateKycStatus: (businessCorporateId?: string) =>
      `/admin/business/corporate/kyc/status/${businessCorporateId}`,
    teamMember: "/admin/team-member",
    addRoleToMember: "/admin/team-member/role",
    getRole: `admin/roles`,
    deleteRole: (id: string) => `/admin/role/${id}`,
    addPermissionToRole: (id: string) => `/admin/role-permission/${id}`,
    userTransactions: (id: string) => `/admin/${id}/transactions`,
    accountPermission: (id: string) => `/account/${id}`,
    getLp: "/admin/liquidity-partner",
    role: (id: string) => `/role/${id}`,
    getAppPages: "/role/all-pages",
    getadminRole: "/role/all-roles",
    getAppPageRole: "/role/role-pages",
    userPage: "/role/user-pages",
    createRole: "/admin/role",
    individualFunctionality: (userId: string) =>
      `/functionalityManagement/user/${userId}`,
    liquidity_partner: "/admin/liquidity-partner",
    lpOtp: "/admin/liquidity-partner/send/otp",
    modifyLp: (id: string) => `admin/liquidity-partner/${id}`,
    stablecoinLP: "/admin/stable-liquidity-partner",
    onramp: "/admin/stable-liquidity-partner-onramp",
    offramp: "/admin/stable-liquidity-partner-offramp",
    modifyStableLP: (id: string) => `/admin/stable-liquidity-partner/${id}`,
    selectLp: (id: string) => `/admin/liquidity-partner/select/${id}`,
    getLpById: (id: string) => `/admin/stable-wallet-by-lp/${id}`,
  },
  account: {
    allAccount: "/backoffice/accounts/NGN",
    currency: (currency: string) => `/backoffice/accounts/${currency}`,
  },
  revenue: {
    allRevenue: "/backoffice/revenues",
  },
  transactions: {
    allTrx: "/backoffice/transactions",
  },
  balances: {
    index: "/backoffice/balances/all",
    account: "/backoffice/total-balance",
  },
};



export const makePostRequest = async (
  data: any,
  url: string,
  includeAuthHeader: boolean = true
) => {
  try {
    // Verify encryption setup first
    verifyEncryptionSetup();

    const { dt, ky } = await generateAndEncryptData(JSON.stringify(data));

    // console.log("Data encrypted successfully");
    // console.log("Making request to:", `${BASEURL}${url}`);

    const response = await axios.post(
      `${BASEURL}${url}`,
      {
        dt,
        ky,
      },
      {
        headers: {
          "Content-Type": "application/json",
          ...(includeAuthHeader && {
            "x-access-token": localStorage.getItem("accessToken") as string,
          }),
        },
      }
    );

    return response;
  } catch (error) {
    // console.error("Request failed:", error);
    //@ts-ignore
    if (error.message.includes("Public key")) {
      throw new Error(
        "Encryption configuration error. Check environment setup."
      );
    }
    throw error;
  }
};

export const makePostRequestWithCustomHeaders = async (
  data: any,
  url: string,
  headers?: any
) => {
  const { dt, ky } = await generateAndEncryptData(JSON.stringify(data));

  const temp = await fetch(`${BASEURL}${url}`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-access-token": localStorage.getItem("accessToken") as string,
      ...headers,
    },
    body: JSON.stringify({
      dt,
      ky,
    }),
  });

  if (!temp.ok) {
    throw new Error(await temp.text());
  }

  const result = await temp.json();
  return result;
};

export const makePatchRequest = async (
  data: any,
  url: string,
  includeAuthHeader: boolean = true
) => {
  const { dt, ky } = await generateAndEncryptData(JSON.stringify(data));

  return await axios.patch(
    `${BASEURL}${url}`,
    {
      dt,
      ky,
    },
    {
      headers: {
        "x-access-token": localStorage.getItem("accessToken") as string,
      },
    }
  );
};

export const makePutRequest = async (
  data: any,
  url: string,
  includeAuthHeader: boolean = true
) => {
  const { dt, ky } = await generateAndEncryptData(JSON.stringify(data));

  return await axios.put(
    `${BASEURL}${url}`,
    {
      dt,
      ky,
    },
    {
      headers: {
        "x-access-token": localStorage.getItem("accessToken") as string,
      },
    }
  );
};

export const makeDeleteRequest = async <T = any>(
  url: string,
  includeAuthHeader: boolean = true
) => {
  // Delete requests typically don't have a body, so no encryption needed
  return await axios.delete<T>(`${BASEURL}${url}`, {
    headers: {
      "x-access-token": localStorage.getItem("accessToken") as string,
    },
  });
};

export const makeGetRequest = async <T = any>(
  url: string,
  params?: PaginationParams,
  includeAuthHeaders: boolean = true
) => {
  // GET requests don't have a body, so we encrypt the query params if they exist
  let finalUrl = `${BASEURL}${url}`;

  // If params exist, append them as regular query parameters
  if (params) {
    const queryString = new URLSearchParams();
    // Convert params object to URL search params
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        queryString.append(key, value.toString());
      }
    });

    // Append query string to URL if there are parameters
    const queryStr = queryString.toString();
    if (queryStr) {
      finalUrl += `?${queryStr}`;
    }
  }

  const response = await axios.get<T>(finalUrl, {
    headers: {
      "x-access-token": localStorage.getItem("accessToken") as string,
    },
  });
  return response;
};
